import { arrayCreateSuite } from "@tevari/helpers";
import { FunctionComponent, memo } from "react";

import styles from "./CriteriumList.module.scss";

import CriteriumItem, { CriteriumItemSkeleton } from "@components/referential/criterium/criteriumItem";
import { IBrandSource } from "@lib/store/models/brandsModels";
import { ICriteriumNode } from "@lib/store/models/nodesModels";

export interface ICriteriumListProps {
  sectionName: string;
  criteriums: ICriteriumNode[];
  loading?: boolean;
  brandSourcesByCriteriumId?: { [id: string]: IBrandSource[] };
}

const CriteriumList: FunctionComponent<ICriteriumListProps> = ({
  sectionName,
  criteriums,
  loading = false,
  brandSourcesByCriteriumId,
}) => {
  const _renderCriteriumNodeItem = (criterium: ICriteriumNode): JSX.Element => {
    return (
      <CriteriumItem
        sectionName={sectionName}
        criterium={criterium}
        brandSources={brandSourcesByCriteriumId?.[criterium.id] ?? []}
        key={criterium.id}
      />
    );
  };

  const _renderSkeleton = () => (
    <>
      {arrayCreateSuite(3).map((index) => (
        <CriteriumItemSkeleton key={index} />
      ))}
    </>
  );

  return (
    <div className={styles["criterium-list"]}>
      {loading
        ? _renderSkeleton()
        : !!criteriums &&
          criteriums
            .filter(({ displayed, isVirtual }) => displayed !== false && isVirtual !== true)
            .map((criterium) => _renderCriteriumNodeItem(criterium))}
    </div>
  );
};

export default memo(CriteriumList);
